export const styles = {
  footer: {
    position: "absolute",
    width: "100%",
    textAlign: "center",
    bottom: "0",
    color: "secondary.dark",
    bgcolor: "primary.light",
    fontFamily: "monospace",
    fontSize: "16px",
    zIndex: "2",
  },
};
